import React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import {UISref} from '@uirouter/react'
import {ConfirmDialog} from '../common.coffee'

export class Logo extends React.Component
  render: () ->
    style = {maxHeight: "100%", paddingLeft: "1%", cursor: 'pointer'}
    Object.assign(style, @props.style) if @props.style?
    
    <UISref to='teacherDashboard'><img src="#{window.config.s3_assets}images/logo-dark-text.png" style={style}/></UISref>

export class AboutDialog extends React.Component
  toggleLogging: =>
    logRocket = localStorage.getItem('logRocket')
    if logRocket? && logRocket is 'true'
      localStorage.removeItem('logRocket')
    else
      localStorage.setItem('logRocket', 'true')
      window.location.reload()
    @forceUpdate()

  render: ->
    <ConfirmDialog
      dialogId="about"
      visible={@props.visible}
      cancel_button_text={null}
      cancel={@props.hide}
      confirm={@props.hide}
      title="About Elephant Learning Classroom"
    >
      <p>
        This is application was designed for the classroom in order to aggregate statistics on 20+ students.        
      </p>

      <p>
        Welcome to the Elephant Learning Classroom.
      </p>

      <div><strong>Web Version:</strong> 2.{window.config.version || "localhost"}<br/></div>
      {
        if window.app.isApp()
          <div><strong>App Version:</strong> {window.config.appVersion}</div>
      }
      <div onClick={@toggleLogging}>
        <strong>Remote Logging:</strong> {
          logRocket = localStorage.getItem('logRocket')
          if logRocket then "On" else "Off"
        }
      </div>
    </ConfirmDialog>


export default class TitleBar extends React.Component
  constructor: (props) ->
    super props
    @state =
      menuItems: []
      activeIndex: {}
      show_about: false
      anchorEl: null

  hide_about: () =>
    @setState({show_about: false})

  changeSlider: (e) =>
    @setState({activeIndex: e.target.value}, () ->
        if @props.goToSlide
          @props.goToSlide(@state.activeIndex)
    )

  logOut: =>
    console.log "CALLED LOGOUT!"
    window.app.loopbackAPI.logout()
    if window?.app?.isApp()
      if window.app.isAndroid()
        window.location = "file:///android_asset/www/index.html"
      else
        window.location = "/"
    else
      window.location = "/"

  help: =>
    window.open("/knowledgebase", "_blank")

  getMenuItems: =>
    # helper function for creating menu buttons
    menuButton = ({key, to, params, text, onClick}) =>
      handleClick = () =>
        @handleMenuClose()
        onClick?()

      return if to?
        <UISref key={key || text} to={to} params={params}>
          <MenuItem onClick={@handleMenuClose}>{text}</MenuItem>
        </UISref>
      else
        <MenuItem key={key || text} onClick={handleClick}>{text}</MenuItem>

    # create items
    menuItems = []
    menuItems.push menuButton(text: window.t?("Manage Account") || "Manage Account", to:"account")
    #menuItems.push menuButton(text: "Classroom Fund", to:"classroom_fund")
    if !window.app?.isStudentLock() && @hasStudents()
      menuItems.push menuButton(text: window.t?("QR Logins") || "QR Logins", to:"tokens")
      if window.app?.activeStudentIndex?
        student = window.app.students[window.app.activeStudentIndex]
        if student?.posetProfiles?
          exam = (pp for pp in student.posetProfiles when pp.exam)
          if exam.length == 0
            menuItems.push menuButton(text: window.t?("Placement Report") || "Placement Report", to:"long_milestone_report", params:{studentId: window.app.activeStudentId})
            if window.app.isApp? && !window.app.isApp()
              menuItems.push menuButton(text: window.t?("Progress Report") || "Progress Report", onClick: @progressReport)
            else
              menuItems.push menuButton(text: window.t?("Progress Report") || "Progress Report", to:"student_report", params:{studentId: window.app.activeStudentId})


    menuItems.push menuButton(text: window.t?("About") || "About", onClick: @about)
    menuItems.push menuButton(text: window.t?("Help") || "Help", onClick: @help)
    menuItems.push menuButton(text: window.t?("Log out") || "Log out", onClick: @logOut)

    return menuItems

  about: =>
    console.log "ABOUT!"
    @setState {show_about: true}

  hasOwnStudents: () =>
    students = window.app.students
    for student in students
      if student.id
        return true
    return false

  hasStudents: () =>
    return @hasOwnStudents() || window.app.sharedStudents.length > 0

  handleMenuOpen: (event) =>
    @setState {anchorEl: event.currentTarget}

  handleMenuClose: =>
    @setState {anchorEl: null}

  render: ->
    menuOpen = Boolean(@state.anchorEl)
    return (
      <div className="el-title-bar no-print">
        <AboutDialog visible={@state.show_about} hide={@hide_about}/>
        <Logo />
        <div id="loginEmail" style={{visibility: "hidden"}}>{window.app.login.email}</div>
        <div className="dashboard_menu_buttons" >
          <UISref to="teacherDashboard"><Button variant="text">Dashboard</Button></UISref>
          <IconButton
            onClick={@handleMenuOpen}
            aria-controls={if menuOpen then "title-bar-menu" else undefined}
            aria-haspopup="true"
            aria-expanded={if menuOpen then 'true' else undefined}
          >
            <Icon>menu</Icon>
          </IconButton>
          <Menu
            id="title-bar-menu"
            anchorEl={@state.anchorEl}
            open={menuOpen}
            onClose={@handleMenuClose}
            className="el-above-widget"
          >
            {@getMenuItems()}
          </Menu>
        </div>
      </div>
    )

